import { Loader } from "./Loader";
import { Source } from "./Source";
import { Sampler } from "./Sampler";
import { Channel } from "./Channel";

export class Animation {

    public sources: Source[];
    public samplers: Sampler[];
    public channels: Channel[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let sourceListResult = loader.util.readIdentityList<Source>(dataView, offset);
        this.sources = sourceListResult.items;
        offset = sourceListResult.offset;

        let samplerListResult = loader.util.readIdentityList<Sampler>(dataView, offset);
        this.samplers = samplerListResult.items;
        offset = samplerListResult.offset;

        let channelListResult = loader.util.readIdentityList<Channel>(dataView, offset);
        this.channels = channelListResult.items;
        offset = channelListResult.offset;
    }
}
